import React, { useEffect, useState, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { MdDeleteOutline } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ApiService from "../../../services/ApiService";
import { DotLoaderComp } from '../../../components/DotLoader/index';
import { ShowErrorToast, ShowSuccessToast } from '../../../components/toaster/toast';

export const MyPlan = ({ }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await ApiService.getModules();
        setRows(response.data);
      } catch (error) {
        ShowErrorToast("Failed to fetch modules.");
        console.error("Error fetching modules:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleEdit = (row) => {
    navigate(`/update-module/${row.id}`);
  };
  
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this module?");
    if (!isConfirmed) return;

    setLoading(true);
    try {
      await ApiService.deleteModule(id);
      ShowSuccessToast("Module deleted successfully!");
      setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    } catch (error) {
      ShowErrorToast("Failed to delete module.");
      console.error("Error deleting module:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "name", headerName: "Module Name", minWidth: 100, flex: 1 },
    { field: "type", headerName: "Module", minWidth: 100, flex: 1 },
    { field: "annual_limit", headerName: "Annual Limit", minWidth: 100, flex: 1 },
    { field: "cover", headerName: "Cover For", minWidth: 100, flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 100,
      flex: 0.5,
      renderCell: (params) => (
        <div className="flex h-full mt-3">
          <FaRegEdit size={21} className="cursor-pointer text-[#333547]" onClick={() => handleEdit(params.row)} />
          <MdDeleteOutline size={24} className="cursor-pointer text-[#EE1919]" onClick={() => handleDelete(params.row.id)} />
        </div>
      )
    }
  ];

  if (loading) {
    return (
      <div style={{ backgroundColor: "#f9f7f2" }} className='h-screen w-full flex items-center justify-center'>
        <DotLoaderComp />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-md ">
        <div className="md:h-[400px]"> 
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            className="rounded-lg border border-gray-300"
            sx={{
              overflow: "hidden",
              "& .MuiDataGrid-columnHeader": {
                overflow: "hidden",
              },
              "& .MuiDataGrid-cell": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
          />
        </div>
      </div>
  );
}
